module.exports = __webpack_public_path__ + "static/media/selection.3bdeaaef.png";